module.exports = __webpack_public_path__ + "img/msu3.ecc5a6d0.png";